<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p><span dir="rtl">هل ستكفي الأسطُر؟ كُلّ عبارات الامتنان لبريق أعَيُنِهم عند لَمس أَحرفِ كتاباتِي، لَهفتهم الدَافِئة لقراءةِ المزيد، حُقول وُدٍّ مَاطِرة، رفِيق ظِلٍّ كَان بِالجِوار يسقي كُلَّ سَطر لِيكتمِل، لِتَرقُص معَي كُلُّ الصفحات، فَأنا حَقَّقتُ ما أريد.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?3fb53a54